import '@ant-design/v5-patch-for-react-19';
import Head from 'next/head';
import 'civitfun-ocr-ui-component/style.css';
import '../styles/globals.css';
import '../dayjsConfig';
import { Montserrat } from 'next/font/google';

import { BookingContextProvider } from '../shared/contexts/Booking.context';
import { LanguageContextProvider } from '../shared/contexts/Language.context';
import { ErrorContextProvider } from '../shared/contexts/Error.context';
import { ThemeContext, ThemeContextProvider } from '../shared/contexts/Theme.context';
import { LoginContextProvider } from '../shared/contexts/Login.context';
// import 'aliceonboarding/dist/aliceonboarding.css';
import { useState, useEffect, useContext } from 'react';
import * as GtmUtils from '../shared/utils/GtmUtils';
import apiConfig from '../shared/config/api.config';
import 'react-phone-input-2/lib/plain.css';
import { createMetricsCookie } from '../shared/utils/cookies';

import { ConfigProvider } from 'antd';

const montserrat = Montserrat({
  subsets: ['latin'],
  weight: ['400', '500', '700'],
  display: 'swap',
  variable: '--font-montserrat',
});

function MyApp({ Component, pageProps }) {
  const [gAnalyzed, setGAnalyzed] = useState(false);
  const [title, setTitle] = useState('Check-in');
  const [cookiesEnabled, setCookiesEnabled] = useState(null);

  useEffect(() => {
    document.documentElement.classList.add(montserrat.variable);

    return () => {
      document.documentElement.classList.remove(montserrat.variable);
    };
  }, []);

  useEffect(() => {
    if (process.env.NODE_ENV == 'production') {
      if (!gAnalyzed) {
        GtmUtils.initialize();
        setGAnalyzed(true);
      }
    }
    setTitle(window.location.hostname?.includes('checkout') ? 'Check-out' : 'Check-in');
    const processType = window.location.href.includes('checkout') ? 'checkout' : 'checkin';

    try {
      localStorage.setItem('process-type', processType);
      setCookiesEnabled(true);
      createMetricsCookie();
    } catch (error) {
      console.error(error);
      setCookiesEnabled(false);
    }

    apiConfig.setUpInterceptors();
  }, []);

  if (cookiesEnabled === null) {
    return <></>;
  } else if (!cookiesEnabled) {
    return (
      <h1>You must enable cookies in your browser to be able to access the online check-in</h1>
    );
  } else
    return (
      <div className={montserrat.variable}>
        <div id="dom-events-subscriber" />

        <Head>
          <title>{title}</title>
          <meta name="robots" content="noindex" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1"
          ></meta>
        </Head>

        <LanguageContextProvider>
          <ThemeContextProvider>
            <AntdThemeProvider>
              <LoginContextProvider>
                <ErrorContextProvider>
                  <BookingContextProvider>
                    <Component {...pageProps} />
                  </BookingContextProvider>
                </ErrorContextProvider>
              </LoginContextProvider>
            </AntdThemeProvider>
          </ThemeContextProvider>
        </LanguageContextProvider>
      </div>
    );
}

function AntdThemeProvider({ children }) {
  const { state: theme } = useContext(ThemeContext);

  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: 'var(--font-montserrat)',
          colorPrimary: theme?.secondaryColor || '#000000',
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
}

export default MyApp;
